export const NAV_LINKS = [
  {
    id: 1,
    scrollTo: 'aboutProduct',
    title: 'Про продукт',
  },
  {
    id: 2,
    scrollTo: 'insurance',
    title: 'Страховка',
  },
  {
    id: 3,
    scrollTo: 'howWeWorking',
    title: 'Как мы работаем',
  },
  {
    id: 4,
    scrollTo: 'advantages',
    title: 'Преимущества',
  },
];
